import PropTypes from "prop-types";
import React from "react";
import Img from "gatsby-image";
import { Link, StaticQuery, graphql } from "gatsby";
import { media, styled } from "./mediaCSS";
import DRLogo from "./DRLogo";

import MobilePWAFooter from "./MobilePWAFooter";

const MobileFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  font-size: 20pt;
  padding: 10px;

  .footerLogo {
    margin-right: 10px;
  }

  background-color: #c1c1c1;
  ${media.tablet_desktop`
    display: none;
  `}

  ${media.mobilePWA`
    display: none;
  `}
`;

const DesktopTabletFooter = styled.footer`
  font-size: 20pt;
  display: none;
  background-color: #d4d4d4;
  border-top: 3px solid #aaaaaa;
  min-height: 125px;

  ${media.tablet_desktop`
    display: flex;
  `}
`;

const FooterSpacerLeft = styled.div`
  flex: 1 20%;
  display: none;
  ${media.desktop`
  display: block;
  `}
`;

const FooterSpacerRight = styled.div`
  flex: 1 20%;
  display: none;
  ${media.desktop`
  display: block;
  `}
`;
const FooterContent = styled.div`
  display: flex;

  flex: 3 100%;
`;

const FooterLeft = styled.div`
  flex: 1;
  padding: 10px;
`;

const FooterRight = styled.div`
  flex: 1;
  padding: 10px;
  text-align: right;
`;

const Footer = ({ siteTitle }) => [
  <MobileFooter>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="http://digirest.com"
      aria-label="Digital Restaurant"
    >
      <DRLogo />
    </a>
  </MobileFooter>,
  <DesktopTabletFooter>
    <FooterSpacerLeft />
    <FooterContent>
      <FooterLeft></FooterLeft>
      <FooterRight>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="http://digirest.com"
          aria-label="Digital Restaurant"
        >
          <DRLogo />
        </a>
      </FooterRight>
    </FooterContent>
    <FooterSpacerRight />
  </DesktopTabletFooter>,
  <MobilePWAFooter />,
];

Footer.propTypes = {
  siteTitle: PropTypes.string,
};

Footer.defaultProps = {
  siteTitle: ``,
};

export default Footer;
